import React from "react";

export default function Navigation() {
  return (
    <>
      <h1>Navigation Here</h1>
    </>
  );
}
